// assets
import { CalendarOutlined } from "@ant-design/icons";
import { CompassOutlined } from "@ant-design/icons";
import { EnvironmentOutlined } from "@ant-design/icons";
import { LoginOutlined } from "@ant-design/icons";
import { PhoneOutlined } from "@ant-design/icons";
import { RocketOutlined } from "@ant-design/icons";
import { ScheduleOutlined } from "@ant-design/icons";
import { TeamOutlined } from "@ant-design/icons";

// type
import { NavItemType } from "types/menu";

const icons = {
  CalendarOutlined,
  CompassOutlined,
  EnvironmentOutlined,
  LoginOutlined,
  PhoneOutlined,
  RocketOutlined,
  ScheduleOutlined,
  TeamOutlined,
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages: NavItemType = {
  id: "group-pages",
  title: "Pages",
  type: "group",
  children: [
    {
      id: "api-pages",
      title: "API Pages",
      type: "collapse",
      icon: icons.ScheduleOutlined,
      children: [
        {
          id: "api-pages-auth",
          title: "Auth APIs",
          type: "item",
          url: "/pages/apis/auth",
          icon: icons.LoginOutlined,
        },
        {
          id: "api-pages-positions",
          title: "Position APIs",
          type: "item",
          url: "/pages/apis/positions",
          icon: icons.TeamOutlined,
        },
        {
          id: "api-pages-airports",
          title: "Airport APIs",
          type: "item",
          url: "/pages/apis/airports",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "api-pages-users",
          title: "User APIs",
          type: "item",
          url: "/pages/apis/users",
          icon: icons.TeamOutlined,
        },
        {
          id: "api-pages-item-types",
          title: "Item Type APIs",
          type: "item",
          url: "/pages/apis/item-types",
          icon: icons.CompassOutlined,
        },
        {
          id: "api-pages-assets",
          title: "Asset APIs",
          type: "item",
          url: "/pages/apis/assets",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "api-pages-cleaning-task-types",
          title: "Cleaning Task Type APIs",
          type: "item",
          url: "/pages/apis/cleaning-task-types",
          icon: icons.CalendarOutlined,
        },
        {
          id: "api-pages-shift-definitions",
          title: "Shift Definition APIs",
          type: "item",
          url: "/pages/apis/shift-definitions",
          icon: icons.CalendarOutlined,
        },
        {
          id: "api-pages-availability",
          title: "Availability APIs",
          type: "item",
          url: "/pages/apis/availability",
          icon: icons.ScheduleOutlined,
        },
        {
          id: "api-pages-work-areas",
          title: "Work Area APIs",
          type: "item",
          url: "/pages/apis/work-areas",
          icon: icons.EnvironmentOutlined,
        },
        {
          id: "api-pages-lines",
          title: "Line APIs",
          type: "item",
          url: "/pages/apis/lines",
          icon: icons.EnvironmentOutlined,
        },
      ],
    },
    {
      id: "maintenance",
      title: "Maintenance",
      type: "collapse",
      icon: icons.RocketOutlined,
      isDropdown: true,
      children: [
        {
          id: "error-404",
          title: "Error 404",
          type: "item",
          url: "/maintenance/404",
          target: true,
        },
        {
          id: "error-500",
          title: "Error 500",
          type: "item",
          url: "/maintenance/500",
          target: true,
        },
        {
          id: "coming-soon",
          title: "Coming Soon",
          type: "item",
          url: "/maintenance/coming-soon",
          target: true,
        },
        {
          id: "under-construction",
          title: "Under Construction",
          type: "item",
          url: "/maintenance/under-construction",
          target: true,
        },
      ],
    },
    {
      id: "contact-us",
      title: "Contact Us",
      type: "item",
      url: "/contact-us",
      icon: icons.PhoneOutlined,
      target: true,
    },
  ],
};

export default pages;
